import { Standard } from '@getvim/vim-connect';

export const diagnosis: Standard.Entities.Diagnosis = {
  description: '',
  code: '',
  note: '',
};
